<template>
  <div class="main-content" :style="[ShouldDisplayNewPricingPlanWidget ? {'background-color': '#f8f8f8'} : {}]">
    <div class="top-links" :class="{ 'ml-15 mr-30 bg-white' : ShouldDisplayNewPricingPlanWidget}">
      <a :href="$sbAppSettings.photoPrint('/Home/QuickSetup')" v-t="'BackToQuickSetup'"></a>
    </div>
    <base-header :heading="$t('Header')"
                  :description="''" :class="{ 'ml-15 mr-30 bg-white' : ShouldDisplayNewPricingPlanWidget}" :style="[ShouldDisplayNewPricingPlanWidget ? {'width': 'auto'} : {}]">
      <div slot="action">
        <sb-button type="a" :href="$sbAppSettings.photoPrint('/Admin')" v-t="'ImpersonateDifferentUser'"></sb-button>
      </div>
    </base-header>
    <div class="impersonated-account-info" :class="{ 'ml-15 mr-30 bg-white' : ShouldDisplayNewPricingPlanWidget}">
      <h3 v-t="'ImpersonatedAccount'"></h3>
      <div>{{$t('Email')}} {{impersonatedUserInfo.impersonatedEmail}}</div>
      <div>{{$t('UserId')}} {{impersonatedUserInfo.impersonatedUserId}}</div>
      <div>{{$t('TotalNumberOfOrders')}} {{totalOrders}}</div>
    </div>
    <AdminEditingPage></AdminEditingPage>
  </div>
</template>
<script>
import AdminEditingPage from '@/components/admin/AdminEditingPage'
export default {
  name: 'Admin',
  components: {
    AdminEditingPage
  },
  destroyed () {
    this.$shipBobStore.unregisterModule('admin')
  },
  data () {
    return {
      datastoreLocation: 'admin/'
    }
  },
  created () {
    this.$shipBobStore.dispatch('admin/getOrdersInfo')
  },
  computed: {
    impersonatedUserInfo () {
      return this.$shipBobStore.getters['user/getUserForAdminPage']
    },
    totalOrders () {
      return this.$shipBobStore.getters[this.datastoreLocation + 'totalOrders']
    },
    ShouldDisplayNewPricingPlanWidget() {
      return this.$shipBobStore.getters["shouldDisplayNewPricingPlanWidget"];
    },
  },
  i18n: {
    messages: {
      'en-US': {
        Header: 'Admin',
        BackToQuickSetup: 'Back to Quick Setup',
        ImpersonatedAccount: 'Impersonated Account:',
        ImpersonateDifferentUser: 'Impersonate a different user',
        Email: 'Email:',
        UserId: 'UserId:',
        TotalNumberOfOrders: 'Total # of Orders:'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/../assets/scss/shipbob-custom/components/admin/_admin.scss';
</style>

